import React, { useCallback, useEffect } from "react";
import { Panel, PanelBody, PanelHeader } from "../../util/panel";
import {
  Button,
  Col,
  Icon,
  notification,
  Popconfirm,
  Row,
  Spin,
  Table,
  Typography,
} from "antd";
import TabUnderLine from "../../../components/TabUnderLine";
import { FaCogs, FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { axios } from "../../../utils/useAxios";
import { useState } from "react";
import SearchDocument from "./components/SearchDocument";
import { useMemo } from "react";
import { getUser } from "../../../utils";

const tabList = [
  { title: "ร่างคำขอเบิกสินค้า", value: "draft" },
  { title: "รอดำเนินการ", value: "pending" },
];
const { Text } = Typography;

const Index = ({ match, history }) => {
  const { process: process_params } = match.params;
  const [datalist, setDataList] = useState();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const user = useMemo(() => getUser(), []);
  const [searchOption, setSearchOption] = useState({
    branchCode: user?.department_id === 1 ? "" : (user?.branch_code ?? ""),
    flowStatus: "",
    search: "",
    startDate: "",
    endDate: "",
  });
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: "#",
      dataIndex: "row_id",
      key: "row_id",
      align: "center",
      width: "4%",
    },
    {
      title: "วันที่คำขอ",
      dataIndex: "create_date",
      key: "create_date",
      align: "center",
      width: "10%",
      render: (text) => dayjs(text).format("DD/MM/YYYY HH:mm"),
    },
    {
      title: "รหัสพนักงาน",
      dataIndex: "staff_code",
      key: "staff_code",
      align: "center",
      width: "7%",
    },
    {
      title: "ชื่อพนักงาน",
      dataIndex: "create_by",
      key: "create_by",
      align: "center",
      width: "22%",
    },
    {
      title: "สาขาผู้ขอเบิก",
      dataIndex: "to_branch",
      key: "to_branch",
      align: "center",
      width: "12%",
    },
    {
      title: "คลังที่เบิกออก",
      dataIndex: "from_wh",
      key: "from_wh",
      align: "center",
      width: "12%",
    },
    {
      title: "คลังที่รับเข้า",
      dataIndex: "to_wh",
      key: "to_wh",
      align: "center",
      width: "12%",
    },
    {
      title: "สถานะ",
      dataIndex: "status_name",
      key: "status_name",
      align: "center",
      width: "12%",
      render: (text, record) => {
        const render =
          record.status_name === "ปฏิเสธ" ? (
            <Text type="danger">{text}</Text>
          ) : record.status_name === "อนุมัติ" ? (
            <Text className="text-primary">{text}</Text>
          ) : (
            text
          );
        return render;
      },
    },
    {
      title: <FaCogs />,
      dataIndex: "action",
      align: "center",
      key: "document_no",
      width: "9%",
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 10,
          }}
        >
          <Button
            shape="circle"
            size="small"
            className="bg-primary text-white"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() =>
              history.push({
                pathname: `/requisition-branch/${process_params}/${record.document_no}`,
              })
            }
          >
            <Icon type="eye" />
          </Button>
          {process_params === "draft" && (
            <Popconfirm
              title="ต้องการลบรายการนี้หรือไม่"
              onConfirm={() => handleDelete(record.document_no)}
              okText="ยืนยัน"
              cancelText="ยกเลิก"
              placement="topRight"
              zIndex={1080}
            >
              <Button
                shape="circle"
                size="small"
                className="bg-reds text-white"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Icon type="delete" />
              </Button>
            </Popconfirm>
          )}
        </div>
      ),
    },
  ];

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const response = await axios.post(`/requisition-branch/delete/${id}`);
      fetchDataListWithParams(process_params);
      notification.success({
        message: response?.data?.message,
        placement: "topRight",
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const handleClickProcess = useCallback(
    (pathname) => {
      history.push({ pathname });
    },
    [history],
  );

  const fetchDataListWithParams = useCallback(
    async (
      process_params,
      page = 1,
      limit = 10,
      searchOption = {
        search: "",
        branchCode: "",
        flowStatus: "",
        startDate: "",
        endDate: "",
      },
    ) => {
      setLoading(true);
      try {
        const offset = (page - 1) * limit;
        const res = await axios.get(`/requisition-branch/${process_params}`, {
          params: {
            userBranchCode: user.branch_code,
            offset: offset,
            limit: limit,
            branchCode: searchOption.branchCode,
            flowStatus: searchOption.flowStatus,
            search: searchOption.search,
            startDate: searchOption.startDate
              ? dayjs(searchOption.startDate).format("YYYY-MM-DD")
              : "",
            endDate: searchOption.endDate
              ? dayjs(searchOption.endDate).format("YYYY-MM-DD")
              : "",
          },
        });
        setDataList(res.data.data);
        setPagination((prev) => ({
          ...prev,
          current: page,
          total: res.data.total,
        }));
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    [user],
  );

  const handleSearch = useCallback(
    (search) => {
      fetchDataListWithParams(process_params, 1, 10, search);
    },
    [fetchDataListWithParams, process_params],
  );

  useEffect(() => {
    fetchDataListWithParams(process_params);
  }, [fetchDataListWithParams, process_params]);

  return (
    <Spin spinning={loading}>
      <Panel>
        <PanelHeader>เบิกสินค้าสาขา</PanelHeader>
        <PanelBody>
          <Row className="mb-4 mt-3">
            <Col span={18} offset={3} xxl={{ span: 12, offset: 6 }}>
              <TabUnderLine
                active={process_params}
                list={tabList}
                onClick={handleClickProcess}
              />
            </Col>
          </Row>
          <div style={{ textAlign: "right" }} className="mb-4">
            {process_params === "draft" ? (
              <Link to={`${process_params}/new`}>
                <Button type="primary">
                  <FaPlus className="mr-2" />
                  สร้างรายการเบิกสินค้า
                </Button>
              </Link>
            ) : (
              <SearchDocument
                searchOption={searchOption}
                setSearchOption={setSearchOption}
                fetchDataListWithParams={handleSearch}
              />
            )}
          </div>
          <Table
            dataSource={datalist}
            columns={columns}
            rowKey="id"
            bordered
            pagination={{
              ...pagination,
              showLessItems: true,
              size: "small",
              onChange: (page) => fetchDataListWithParams(process_params, page),
            }}
          />
        </PanelBody>
      </Panel>
    </Spin>
  );
};

export default Index;
